module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/spacing-vertical-sm-dc460c6c34f33f25fb41a129d68637e9.svg";